// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3fD1R","itemTitle":"ClientEmergencyInfo_itemTitle__2WlLI","itemText":"ClientEmergencyInfo_itemText__pyrr3"};